import { Injectable } from '@angular/core';
import { AppEnablementStatus, PartnerAppEnablementStatus } from '@vendasta/marketplace-packages';
import { Observable, ReplaySubject } from 'rxjs';

export interface ChangedProduct {
  productId: string;
  isEnabled: boolean;
}

@Injectable({ providedIn: 'root' })
export class ProductChangeService {
  private _changedPartnerAppEnablementStatus$$: ReplaySubject<PartnerAppEnablementStatus> = new ReplaySubject();

  changePartnerAppEnablementStatus(partnerId: string, appId: string, status: AppEnablementStatus): void {
    this._changedPartnerAppEnablementStatus$$.next({ partnerId, appId, status } as PartnerAppEnablementStatus);
  }

  get changedPartnerAppEnablementStatus$(): Observable<PartnerAppEnablementStatus> {
    return this._changedPartnerAppEnablementStatus$$.asObservable();
  }
}
